module.exports = __webpack_public_path__ + "img/dropdown.9b9a972b.svg";